import { Controller } from '@hotwired/stimulus'

/**
 * This controller is used to determine if the New Activity Indicator should be displayed.
 * It compares the identifiers of existing entries those that are newly persisted.
 * If any new identifiers are missing, the new activity indicator is shown
 */
export default class NewActivityIndicatorController extends Controller {
  static targets = ['indicator', 'existing', 'new']
  connect() {
    super.connect()
    this.enable()
    this.refresh()
  }

  refresh(){
    if (this._disabled) {
      return
    }

    this.newActivityAvailable() ?
      this.indicatorTarget.classList.remove('hidden') :
      this.indicatorTarget.classList.add('hidden')
  }

  newActivityAvailable() {
    const existingActivityIds = this.existingActivityIds()
    const newActivityIds = this.newActivityIds()

    return newActivityIds.some(identifier => !existingActivityIds.includes(identifier))
  }

  disable() {
    this._disabled = true
  }

  enable() {
    this._disabled = false
  }

  existingActivityIds() {
    return this.existingTargets.map(entry => entry.dataset.activityId)
  }

  newActivityIds() {
    return Array.from(this.newTarget.querySelectorAll('li'))
                .map(entry => entry.dataset.activityId)
  }
}
